import { render } from "./Info.vue?vue&type=template&id=d9199346&scoped=true&bindings={}"
import script from "./Info.vue?vue&type=script&lang=ts"
export * from "./Info.vue?vue&type=script&lang=ts"

import "./Info.vue?vue&type=style&index=0&id=d9199346&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d9199346"

export default script